(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("bundle/logger.bundle"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery", "bundle/logger.bundle"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("jquery"), require("bundle/logger.bundle")) : factory(root["jquery"], root["bundle/logger.bundle"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, (__WEBPACK_EXTERNAL_MODULE_jquery__, __WEBPACK_EXTERNAL_MODULE_bundle_logger_bundle__) => {
return 